"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsUnderParentalConsentAge = void 0;
const getIsUnderParentalConsentAge = (config, birthDate) => {
  if (!config?.isEnabled || !birthDate) {
    return false;
  }
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const thisYearBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
  if (today < thisYearBirthday) {
    age -= 1;
  }
  return age < config.parentalConsentAge;
};
exports.getIsUnderParentalConsentAge = getIsUnderParentalConsentAge;